import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { SecurityApiClient } from "../api-client/api-client";
import type { UpdateTraceParams, UpdateTraceResponse } from "../types";

export default function useUpdateTraceMutation(
  options?: UseMutationOptions<UpdateTraceResponse, Error, UpdateTraceParams>
) {
  return useMutation<UpdateTraceResponse, Error, UpdateTraceParams>({
    mutationFn: async (params: UpdateTraceParams) => {
      const res = await SecurityApiClient.updateDemandOfAuthentication(
        params.id,
        params.success,
        params.web_authn_signing_action_id ?? null,
        params.user_otp_input ?? ""
      );
      if (!res.success) {
        throw new Error(res.data.action);
      }
      return res.data;
    },
    ...options
  });
}
